import { Avatar, Button, makeStyles, tokens } from "@fluentui/react-components";
import type { IGraphPickerItem } from "../../../interfaces";
import { UserAvatar } from "../../UserAvatar/UserAvatar";
import { DismissCircleRegular } from "@fluentui/react-icons";

const buildStyle = makeStyles({
    outer: {
        marginRight: "5px",
        position: "relative",
        height: "26px",
        maxWidth: "300px",
        padding: "0",
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase200
    },
    icon: {
        flexShrink: "0",
        position: "relative",
        top: "1px",
        left: "2px",
    },
    title: {
        position: "relative",
        maxWidth: "calc(100% - 24px - 16px)",
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: "5px",
        paddingRight: "5px",
        flexShrink: "1",
        whiteSpace: "nowrap"
    },
    dismiss: {
        flexShrink: "0",
        height: "16px",
        width: "16px"
    }
});

export interface IUserPickerSelectedItemProps {
    userInfo: IGraphPickerItem;
    onSelect(userInfo: IGraphPickerItem): void;
}

export function UserPickerSelectedItem(props: Readonly<IUserPickerSelectedItemProps>) {
    const { userInfo, onSelect } = props;

    const styleClasses = buildStyle();

    const onClick = (ev: React.MouseEvent): void => {
        ev.preventDefault();
        ev.stopPropagation();

        onSelect?.(userInfo);
    };

    const itemIcon = userInfo.type === "group"
        ? <Avatar name={userInfo.displayName} size={20} className={styleClasses.icon} />
        : <UserAvatar userId={userInfo.id} displayName={userInfo.displayName} size={20} className={styleClasses.icon} />;

    return (
        <Button className={styleClasses.outer} appearance="primary" onClick={onClick} shape="circular">
            {itemIcon}
            <div className={styleClasses.title}>
            {
                userInfo.displayName
            }
            </div>
            <DismissCircleRegular className={styleClasses.dismiss}/>
        </Button>
    );
}